export var query = "query getCountryCodes {\n  localeData(language: \"en\") {\n    countries {\n      key\n      shortKey\n    }\n  }\n}";
//# sourceMappingURL=getCountryCodes.graphql.js.map